/* Dutch Line — guest wishlist (no login). localStorage + shareable URL. */
(function () {
  var KEY = 'dutchline_wishlist';

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: a } }));
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var a = read(), i = a.indexOf(h);
    if (i === -1) a.push(h); else a.splice(i, 1);
    write(a);
    return a.indexOf(h) !== -1;
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-wishlist-toggle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function bindButtons(scope) {
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wlBound) return;
      btn.dataset.wlBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        toggle(btn.getAttribute('data-wishlist-toggle'));
        syncButtons();
      });
    });
  }

  function shareUrl() {
    var a = read();
    var base = (window.DutchlineWishlist && window.DutchlineWishlist.pageUrl) || '/pages/wishlist';
    return a.length ? base + '?items=' + encodeURIComponent(a.join(',')) : base;
  }
  function ingestFromUrl() {
    var items = new URLSearchParams(window.location.search).get('items');
    if (!items) return read();
    var incoming = items.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var cur = read();
    incoming.forEach(function (h) { if (cur.indexOf(h) === -1) cur.push(h); });
    write(cur);
    return cur;
  }

  window.DutchlineWishlist = Object.assign(window.DutchlineWishlist || {}, {
    read: read, has: has, toggle: toggle, shareUrl: shareUrl,
    ingestFromUrl: ingestFromUrl, syncButtons: syncButtons,
    bindButtons: bindButtons, updateCount: updateCount
  });

  function init() { updateCount(); bindButtons(document); syncButtons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { bindButtons(e.target); syncButtons(); });
})();